import { KnownErrorTag } from "./KnownErrorTag";

export const TagLabel: Record<KnownErrorTag, string> = {
    [KnownErrorTag.ReconciliationEmployee]:
        "Теперь Экстерн проверяет, что данные по вашим сотрудникам заполнены корректно. [Подробнее](https://support.kontur.ru/extern/80845-sverki_po_sotrudnikam_pri_proverke_otchetov)",
};
